import {
  BooleanField,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  NumberField,
  ShowButton,
  TextField,
} from "react-admin";
import { CouponProductType, CouponTypeEnum } from "../../enums/CouponTypeEnum";
import {useAppSelector} from "../../store/hooks";
import ResourceSelectDialogButton from "../Common/ResourceSelectDialogButton";
import { formatDateTime } from "../../utils/DateTimeUtils";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
  {
    type: "select",
    label: "Coupon Type",
    source: "couponType",
    options: Object.values(CouponTypeEnum).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    type: "select",
    label: "Product Type",
    source: "productType",
    options: Object.values(CouponProductType).map((value) => ({
      value,
      label: value,
    })),
  },
  { type: "text", label: "Coupon Code", source: "couponCode" },
];

const CouponListV2 = (props: any) => {
  const isCustomSelectOpen = useAppSelector(
      (state) => state.customSelect.value.open
  );
  return (
    <List
      {...props}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Coupons V2">
      <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
        {isCustomSelectOpen && <ResourceSelectDialogButton />}
        <NumberField source="id" />
        <TextField source="couponCode" sortable={false} />
        <TextField source="couponValue" sortable={false} />
        <TextField source="productType" sortable={false} />
        <TextField source="couponType" sortable={false} />
        <BooleanField label="Coupon Status" source="isActive" />
        <TextField source="maximumDiscountAmount" sortable={false} />
        <TextField source="maximumUsageLimit" sortable={false} />
        <TextField source="minimumOrderValue" sortable={false} />
        <TextField source="reason" sortable={false} />
        <TextField source="usageLimitPerCustomer" sortable={false} />
        <TextField source="uniqueCustomerUsed" sortable={false} />
        <TextField source="totalTimesUsed" />
        <TextField source="couponHeader" sortable={false} />
        <TextField source="couponDescription" sortable={false} />
        <TextField source="createdByEmail" sortable={false} />
        <FunctionField
          label="Expires At"
          render={(record: any) =>
            record?.expiresAt ? formatDateTime(record.expiresAt) : "-"
          }
        />
        <ShowButton />
        <EditButton/>
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};

export default CouponListV2;
